import { AppUser } from '@novakid/frontend-core';

export class UserService extends AppUser {
  private static instance: UserService | null = null;

  static getInstance() {
    if (!this.instance) {
      this.instance = new UserService();
    }

    return this.instance;
  }

  public static get userId() {
    return this.getInstance().userId;
  }

  public static get authToken() {
    return this.getInstance().authToken;
  }

  public static get hasUserCredentials() {
    return this.getInstance().hasUserCredentials;
  }
}